export const currentTenantKeys = {
  all: ['currentTenant'] as const,
  detail: (tenantId: number | null) => [...currentTenantKeys.all, tenantId] as const,
  ownersAndAdmins: ['currentTenantOwnersAndAdmins'] as const,
};
